import { Spin, notification } from 'antd';
import { TextComponent } from 'baseComponents/TextComponent';
import { AdminPageWrapper } from 'components/layouts/AdminPageWrapper';
import { queryClient } from 'constants/query-client';
import { useNavigate } from 'react-router';
import { AdminUserForm } from 'components/AdminUserForm';
import { useAddUser } from 'hooks/useAddUser';

export const AdminAddUser = () => {
  const navigate = useNavigate();
  const [api, contextHolder] = notification.useNotification();

  const { mutate: addUser, isPending } = useAddUser({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['users'],
      });
      navigate('/admin/manage/users', { state: 'success' });
    },
    onError: () => {
      return api.error({
        message: 'Invite new user error',
        description: `Something went wrong with your action. Please try again later.`,
        duration: 3,
      });
    },
  });

  return (
    <AdminPageWrapper sidebar={<div style={{ width: 160 }} />}>
      {contextHolder}
      <TextComponent size='table-title-size' text='Invite new user' />
      <Spin spinning={isPending}>
        <AdminUserForm
          submitButtonLabel='Submit'
          onCancel={() => navigate('/admin/manage/users')}
          onSubmit={(data) => {
            addUser({
              phone_number: data.phone,
              franchise_owner_id: data.franchiseOwner,
              email: data.email,
              name: data.name,
              role_id: data.role!,
              store_ids: data.stores,
            });
          }}
        />
      </Spin>
    </AdminPageWrapper>
  );
};
